/**
 * SDK configuration for using the ory-next library.
 */
export const edgeConfig = {
  basePath: "/api/.ory",
  baseOptions: {
    withCredentials: true,
  },
}
